import React, { useState } from "react";
import RangeDataOption from "./RangeDataOption";
import { getRUCEmpresa } from "redux/actions/userActions";
import { useSelector } from "react-redux";
//libreria de consulta de apis
import { httpRepo } from "configurations/axios";
import { useSnackbar } from "notistack";
import { makeStyles, CircularProgress, Backdrop } from "@material-ui/core";
import { parseDate } from "utils/checkDate";

const useStyles = makeStyles((theme) => ({
  input: {
    width: "350px",
  },
  backdrop: {
    zIndex: "3000",
    color: "#fff",
  },
}))
const VoucherReportAuthorizedForItem = () => {
  const tokenUser = useSelector((state) => state.user.tk);
  const { enqueueSnackbar } = useSnackbar();
  var fileSaver = require("file-saver");
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const [options, setOptions] = useState([
    { value: "00", label: "Todos" },
    { value: "01", label: "Factura de operación interna" },
    { value: "02", label: "Factura de importación" },
    { value: "03", label: "Factura de exportación" },
    { value: "06", label: "Nota de crédito genérica" },
    { value: "04", label: "Nota de crédito referente a una o varias FE" },
    { value: "07", label: "Nota de débito genérica" },
    { value: "05", label: "Nota de débito referente a una o varias FE" },
    { value: "08", label: "Factura de zona franca" },
    { value: "09", label: "Reembolso" },
    { value: "12", label: "Anulados" }
  ]);


  function generateReport(startDate, endDate, optionSelect) {
    if (optionSelect.value) {
      let objReport = {};
      objReport = {
        fechaFin: parseDate(endDate, 2),
        fechaInicio: parseDate(startDate, 1),
        rucEmpresa: tokenUser ? getRUCEmpresa(tokenUser) : "",
        tipoComprobante: optionSelect.value,
      };
      getReportIssued(objReport);
    } else {
      enqueueSnackbar(`Seleccione un tipo de comprobante`, {
        variant: "info",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        autoHideDuration: 4000,
      });
    }
  }

  const getReportIssued = async (objReport) => {
    setOpen(true);
    await httpRepo
      .post("reporte/comprobantes/emitidos/detalles", objReport, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        if (response.status === 200) {
          var blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          fileSaver.saveAs(blob, "ReporteComprobantesAutorizadosPorDetalle.xlsx");
          setOpen(false);
        }
      })
      .catch(() => {
        enqueueSnackbar(`No existen datos para los filtros seleccionados`, {
          variant: "info",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        setOpen(false);
      });
  };

  return (
    <div>
      <Backdrop open={open} className={classes.backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <RangeDataOption
        generateReport={generateReport}
        title={"Reporte de Comprobantes Autorizados Por Detalle."}
        options={options}
      ></RangeDataOption>
    </div>
  );
};

export default VoucherReportAuthorizedForItem;
